import PropTypes from 'prop-types';
import React from 'react';
import FormSettings from '../properties/FormSettings';
import PaneHeader from './PaneHeader';

// Phone "Form settings" pane (plan §5.7): Form Settings with Done.
const SettingsPane = ({ onDone, headingRef }) => (
  <section aria-label="Form settings">
    <PaneHeader
      title="Form settings"
      sub="Applies to the whole form"
      onDone={onDone}
      headingRef={headingRef}
    />
    <FormSettings showHeader={false} />
  </section>
);

SettingsPane.propTypes = {
  onDone: PropTypes.func.isRequired,
  headingRef: PropTypes.shape({ current: PropTypes.any }),
};

SettingsPane.defaultProps = { headingRef: undefined };

export default SettingsPane;
